import React, { Component } from 'react'
import { Navbar, Nav, Container } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'

import '../../../assets/sass/pages/landing/layout/header.scss';

class Header extends Component {
    render() {
        return (
            <>
                <header className="header-landing" >
                    <Navbar bg="primary" variant="dark" expand="md">
                        <Container>
                            <Navbar.Brand as={NavLink} to="/">ScoutAfrique</Navbar.Brand>
                            <Navbar.Toggle aria-controls="landing-navbar-collapse" />
                            <Navbar.Collapse id="landing-navbar-collapse">
                                {this.renderNav()}
                            </Navbar.Collapse>
                        </Container>
                    </Navbar>
                </header>
            </>
        )
    }

    renderNav = () => {
        const isRegistred = false;

        return isRegistred ? this.renderUserNav() : this.renderGuestNav();
    }

    renderGuestNav = () => {
        return (
            <Nav className="ml-auto">
                <Nav.Link
                    as={NavLink}
                    to="/contact"
                    className="btn btn-link sm"
                    activeClassName="active"
                >Contact Us</Nav.Link>
                <Nav.Link
                    as={NavLink}
                    to="/pricing"
                    className="btn btn-link sm"
                    activeClassName="active"
                >Pricing</Nav.Link>
                <Nav.Link
                    as={NavLink}
                    to="/signin"
                    className="btn btn-login sm"
                >Login</Nav.Link>
                <Nav.Link
                    as={NavLink}
                    to="/signup"
                    className="btn btn-register sm"
                >Register</Nav.Link>
                {/* <Nav.Link
                    as={'div'}
                    className="theme-switch-wrapper"
                ><ThemeSwitch onThemeChange={this.props.onThemeChange} /></Nav.Link> */}
            </Nav>
        )
    }

    renderUserNav = () => {
        return (
            <Nav className="ml-auto">
                <Nav.Link
                    as={NavLink}
                    to="/contact-us"
                >Contact Us</Nav.Link>
                <Nav.Link
                    as={NavLink}
                    to="/pricing"
                >Pricing</Nav.Link>
                <Nav.Link
                    as={NavLink}
                    to="/dashboard"
                    className="btn btn-login"
                >Dashboard</Nav.Link>
            </Nav>
        )
    }
}

export default Header
